import fetcher from '@/lib/fetcher';
import { App } from '@prisma/client';
import useSWR, { mutate } from 'swr';
import type { ApiResponse } from 'types';

const useApps = (slug: string | undefined) => {
  const url = `/api/teams/${slug}/apps`;

  const { data, error, isLoading } = useSWR<ApiResponse<App[]>>(() => {
    return slug ? url : null;
  }, fetcher);

  const mutateApps = async () => {
    mutate(url);
  };

  return {
    apps: data?.data,
    isLoading,
    error,
    mutate: mutateApps,
  };
};

export default useApps;
